/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMoneyPoolRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {GetMoneyPoolResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const getMoneyPool = (request: GetMoneyPoolRequest, options?: CashRequestOptions) => post<GetMoneyPoolRequest, GetMoneyPoolResponse>("/2.0/cash/get-money-pool", request, {...options, rejectOnError: true })